// src/api/stressAnalyticsApi.js
import apiClient from "./apiClient";

function filenameFromContentDisposition(disposition, fallback) {
  if (!disposition) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/i.exec(disposition);
  if (!match) return fallback;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

const stressAnalyticsApi = {
  // 📊 Obtener analítica de estrés por empresa con filtros opcionales
  getStressAnalyticsByCompanyId: async (companyId, filters = {}) => {
    try {
      const response = await apiClient.get(
        `/analytics/stress/${companyId}`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo analítica de estrés por empresa:", error);
      throw error;
    }
  },

  // 📊 Obtener analítica de estrés global con filtros opcionales
  getStressGlobalAnalytics: async (filters = {}) => {
    try {
      const response = await apiClient.get(`/analytics/global/stress`, {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo analítica de estrés global:", error);
      throw error;
    }
  },

  // 👥 Obtener lista de respondants de estrés por empresa
  getStressRespondantsByCompanyId: async (companyId) => {
    try {
      const response = await apiClient.get(
        `/analytics/stress/${companyId}/stress-respondants`
      );
      return response.data.respondants;
    } catch (error) {
      console.error("Error obteniendo respondants de estrés por empresa:", error);
      throw error;
    }
  },

  // ⬇️ Exportar respondants de estrés (Excel) — devuelve { blob, filename }
  getStressRespondantsByCompanyIdExport: async (companyId) => {
    try {
      const response = await apiClient.get(
        `/analytics/stress/${companyId}/stress-respondants/export`,
        {
          responseType: "blob",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        }
      );

      const filename = filenameFromContentDisposition(
        response.headers["content-disposition"],
        `stress-respondants-${companyId}.xlsx`
      );

      return { blob: response.data, filename };
    } catch (error) {
      console.error("Error exportando respondants de estrés por empresa:", error);
      throw error;
    }
  },

  // 💾 Helper opcional para disparar descarga
  downloadStressRespondantsByCompanyIdExcel: async (companyId) => {
    const { blob, filename } =
      await stressAnalyticsApi.getStressRespondantsByCompanyIdExport(companyId);

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || `stress-respondants-${companyId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
};

export default stressAnalyticsApi;
